module.exports = __webpack_public_path__ + "media/packs/src/assets/images/logo-50f00186394878e7d3f80ff8c1275309.svg";